'use strict';

var flex = require('../../../../../../../../_virtual/flex.cjs');

(function (exports) {

	exports.JustifyContentOptions = void 0;
	(function(JustifyContentOptions) {
	    JustifyContentOptions["center"] = "center";
	    JustifyContentOptions["flexEnd"] = "flex-end";
	    JustifyContentOptions["flexStart"] = "flex-start";
	    JustifyContentOptions["spaceAround"] = "space-around";
	    JustifyContentOptions["spaceEvenly"] = "space-evenly";
	    JustifyContentOptions["spaceBetween"] = "space-between";
	})(exports.JustifyContentOptions || (exports.JustifyContentOptions = {}));
	exports.AlignItemOptions = void 0;
	(function(AlignItemOptions) {
	    AlignItemOptions["center"] = "center";
	    AlignItemOptions["flexEnd"] = "flex-end";
	    AlignItemOptions["flexStart"] = "flex-start";
	})(exports.AlignItemOptions || (exports.AlignItemOptions = {}));
	
} (flex.__exports));
//# sourceMappingURL=flex.cjs.map
